import * as React from "react"

export default function AllVehiclesIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 3.625a6.375 6.375 0 110 12.75 6.375 6.375 0 010-12.75zm0 .75a5.625 5.625 0 100 11.25 5.625 5.625 0 000-11.25zm0 3.25c.207 0 .375.168.375.375v1.625H12a.375.375 0 010 .75h-1.625V12a.375.375 0 01-.75 0v-1.625H8a.375.375 0 010-.75h1.625V8c0-.207.168-.375.375-.375z"
        fill={props.fill}
      />
    </svg>
  )
}